export default [
  'CaptureEmail',
  'CaptureFile',
  'CaptureInput',
  'CaptureNumber',
  'CapturePhone',
  'CaptureSecure',
  'CaptureText',
  'Horizontal',
  'Vertical',
  'Image',
  'Text',
  'List',
  'Proxy',
  'SvgText',
  'Svg',
  'SvgCircle',
  'SvgEllipse',
  'SvgGroup',
  'SvgLinearGradient',
  'SvgRadialGradient',
  'SvgLine',
  'SvgPath',
  'SvgPolygon',
  'SvgPolyline',
  'SvgRect',
  'SvgSymbol',
  'SvgUse',
  'SvgDefs',
  'SvgStop',
  'Router',
  'Route',
  'Link',
]
